<template>
  <section class="card-component">
    <Loading class="splash_loading" v-if="generateCard === ''"></Loading>
    <div class="flex-center">
      <div id="card-container" v-if="generateCard === ''">
        <div class="card-container" v-bind:style="{ 'background-image': 'url(' + background + ')' }">
          <img class="card-flag" :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" />
          <p class="card-sexe" v-if="coureur.sexe === 'HOMME'">H</p>
          <p class="card-sexe" v-else>F</p>

          <p class="card-firstname">{{ coureur.prenom }}</p>
          <p class="card-lastname">{{ coureur.nom }}</p>
          <p class="card-classement">{{ coureur.classement }}</p>
          <p class="card-points">{{ coureur.points }}</p>
          <div class="card-courses">{{ coureur.nb_participations }}</div>
          <div
            class="photo_container"
            v-if="coureur.url_photo"
            v-bind:style="{
              'background-image': 'url(https://sportips.fr/MAR23/upload/' + coureur.url_photo + ')',
            }"
          ></div>
        </div>
      </div>

      <img class="generated_card" :src="generateCard" alt="" />
      <b-button class="btn_generated_card" v-if="display_download" style="margin-top: 10px" @click="launchCardDownload">Télécharger ma carte</b-button>
    </div>
  </section>
</template>
<script>
import * as htmlToImage from "html-to-image";
import Loading from "@/components/Loading.vue";
export default {
  props: ["coureur", "display_download"],
  components: { Loading },
  data() {
    return {
      generateCard: "",
      background: "https://sportips.fr/challenge-maritima/img/bg_carte.png",
    };
  },
  watch: {
    coureur() {
      var _this = this;
      setTimeout(function () {
        _this.createCarteJpg();
      }, 50);
    },
  },
  methods: {
    createCarteJpg() {
      var _this = this;
      try {
        htmlToImage.toPng(document.getElementById("card-container")).then(function (dataUrl) {
          _this.generateCard = dataUrl;
        });
      } catch (error) {
        console.log(error);
      }
    },
    launchCardDownload() {
      var link = document.createElement("a");
      link.download = "Carte_" + this.coureur.nom + "_" + this.coureur.prenom + ".png";
      link.href = this.generateCard;
      link.click();
    },
  },
  created() {
    var _this = this;
    setTimeout(function () {
      _this.createCarteJpg();
    }, 1000);
  },
};
</script>
<style scoped>
.card-component {
  position: relative;
}
.splash_loading {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
#card-container {
  width: 300px;
  height: 482px;
}
.card-container {
  position: relative;
  background-size: cover;
  top: 0;
  left: 0;
  width: 300px;
  height: 482px;
}

.card-firstname {
  font-size: 31px;
  text-align: center;
  position: absolute;
  color: white;
  text-transform: uppercase;
  top: 285px;
  left: 5px;
  width: 292px;
  height: 28px;
  line-height: 28px;
}

.card-lastname {
  font-size: 31px;
  font-weight: bold;
  text-align: center;
  position: absolute;
  color: white;
  text-transform: uppercase;
  top: 325px;
  left: 5px;
  width: 292px;
  height: 28px;
  line-height: 28px;
}

.card-classement {
  font-size: 29px;
  font-weight: bold;
  text-align: center;
  position: absolute;
  color: #ff8500;
  text-transform: uppercase;
  top: 423px;
  left: 34px;
  width: 85px;
  height: 25px;
  line-height: 25px;
}

.card-points {
  font-size: 25px;
  font-weight: bold;
  text-align: right;
  position: absolute;
  color: #7f95d1;
  text-transform: uppercase;
  top: 386px;
  left: 118px;
  width: 100px;
  height: 21px;
  line-height: 21px;
}

.card-courses {
  font-size: 25px;
  font-weight: bold;
  text-align: right;
  position: absolute;
  color: #7f95d1;
  text-transform: uppercase;
  top: 422px;
  left: 118px;
  width: 46px;
  height: 25px;
  line-height: 25px;
}

.card-flag {
  position: absolute;
  height: 20px;
  top: 25px;
  left: 34px;
}

.card-sexe {
  font-size: 27px;
  font-weight: bold;
  text-align: right;
  position: absolute;
  color: #1c2681;
  text-transform: uppercase;
  top: 25px;
  left: 217px;
  width: 52px;
  height: 20px;
  line-height: 20px;
}

.photo_container {
  width: 253px;
  height: 198px;
  position: absolute;
  top: 69px;
  left: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>